import React from 'react';
import {Popover, Button, Icon, message} from 'antd';

import {WeaLocaleProvider, WeaCheckbox} from 'ecCom';

import BackgroundSetting from '../wea-portal-background/Setting';

const getLabel = WeaLocaleProvider.getLabel;

class Toolbar extends React.Component {
    constructor(props) {
        super(props);
        this.onLayoutChange = this.onLayoutChange.bind(this);
    }

    render() {
        const {id, background = {}, layout = {}} = this.props;
        const {top = {}, bottom = {}, left = {}, right = {}} = layout;

        return (
            <div className="wea-portal-layout-toolbar-content">
                <div className="wea-portal-layout-toolbar-item wea-portal-layout-toolbar-item-active">
                    <div className="wea-portal-layout-toolbar-background">
                        <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@olrjpf`}
                            trigger="click"
                            placement="bottomRight"
                            title={getLabel(387750, '背景设置')}
                            content={<BackgroundSetting ecId={`${this && this.props && this.props.ecId || ''}_BackgroundSetting@cx05sz`} background={background} onChange={this.props.onBackgroundChange}/>}
                            overlayClassName="wea-portal-background-setting"
                        >
                            <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                        </Popover>
                    </div>
                    <div className="wea-portal-layout-toolbar-add" title={getLabel(390939, '添加元素')} onClick={() => this.props.onAddElement(id, 'middle')}>
                        <div className="wea-portal-layout-toolbar-add-area wea-portal-layout-toolbar-add-middle">+</div>
                    </div>
                </div>

                <div className="wea-portal-layout-toolbar-spliter"/>

                <div className={`wea-portal-layout-toolbar-item ${top.visible ? 'wea-portal-layout-toolbar-item-active' : ''}`}>
                    <div className="wea-portal-layout-toolbar-check">
                        <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@1xhz9k`} content={getLabel(390940, '顶部栏')} value={top.visible} onChange={(value) => this.onLayoutChange('top', {visible: value === '1'})}/>
                    </div>
                    <div className="wea-portal-layout-toolbar-background">
                        {
                            top.visible ? (
                                <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@4ckucx`}
                                    trigger="click"
                                    placement="bottomRight"
                                    title={getLabel(387750, '背景设置')}
                                    content={<BackgroundSetting ecId={`${this && this.props && this.props.ecId || ''}_BackgroundSetting@3087zt`} background={top.background} onChange={(background) => this.onLayoutChange('top', {background})}/>}
                                    overlayClassName="wea-portal-background-setting"
                                >
                                    <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                                </Popover>
                            ) : <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                        }
                    </div>
                    <div className="wea-portal-layout-toolbar-add" title={getLabel(390941, '添加顶部元素')} onClick={() => this.props.onAddElement(id, 'top')}>
                        <div className="wea-portal-layout-toolbar-add-area wea-portal-layout-toolbar-add-top">+</div>
                    </div>
                </div>

                <div className="wea-portal-layout-toolbar-spliter"/>

                <div className={`wea-portal-layout-toolbar-item ${bottom.visible ? 'wea-portal-layout-toolbar-item-active' : ''}`}>
                    <div className="wea-portal-layout-toolbar-check">
                        <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@mvprs1`} content={getLabel(390942, '底部栏')} value={bottom.visible} onChange={(value) => this.onLayoutChange('bottom', {visible: value === '1'})}/>
                    </div>
                    <div className="wea-portal-layout-toolbar-background">
                        {
                            bottom.visible ? (
                                <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@byg5jp`}
                                    trigger="click"
                                    placement="bottomRight"
                                    title={getLabel(387750, '背景设置')}
                                    content={<BackgroundSetting ecId={`${this && this.props && this.props.ecId || ''}_BackgroundSetting@cjf889`} background={bottom.background} onChange={(background) => this.onLayoutChange('bottom', {background})}/>}
                                    overlayClassName="wea-portal-background-setting"
                                >
                                    <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                                </Popover>
                            ) : <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                        }
                    </div>
                    <div className="wea-portal-layout-toolbar-add" title={getLabel(390943, '添加底部元素')} onClick={() => this.props.onAddElement(id, 'bottom')}>
                        <div className="wea-portal-layout-toolbar-add-area wea-portal-layout-toolbar-add-bottom">+</div>
                    </div>
                </div>

                <div className="wea-portal-layout-toolbar-spliter"/>

                <div className={`wea-portal-layout-toolbar-item ${left.visible ? 'wea-portal-layout-toolbar-item-active' : ''}`}>
                    <div className="wea-portal-layout-toolbar-check">
                        <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@p0qymr`} content={getLabel(390944, '左侧栏')} value={left.visible} onChange={(value) => this.onLayoutChange('left', {visible: value === '1'})}/>
                    </div>
                    <div className="wea-portal-layout-toolbar-background">
                        {
                            left.visible ? (
                                <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@w497mh`}
                                    trigger="click"
                                    placement="bottomRight"
                                    title={getLabel(387750, '背景设置')}
                                    content={<BackgroundSetting ecId={`${this && this.props && this.props.ecId || ''}_BackgroundSetting@fxo5p6`} background={left.background} onChange={(background) => this.onLayoutChange('left', {background})}/>}
                                    overlayClassName="wea-portal-background-setting"
                                >
                                    <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                                </Popover>
                            ) : <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                        }
                    </div>
                    <div className="wea-portal-layout-toolbar-add" title={getLabel(390945, '添加左侧元素')} onClick={() => this.props.onAddElement(id, 'left')}>
                        <div className="wea-portal-layout-toolbar-add-area wea-portal-layout-toolbar-add-left">+</div>
                    </div>
                </div>

                <div className="wea-portal-layout-toolbar-spliter"/>

                <div className={`wea-portal-layout-toolbar-item ${right.visible ? 'wea-portal-layout-toolbar-item-active' : ''}`}>
                    <div className="wea-portal-layout-toolbar-check">
                        <WeaCheckbox ecId={`${this && this.props && this.props.ecId || ''}_WeaCheckbox@x1gp03`} content={getLabel(390946, '右侧栏')} value={right.visible} onChange={(value) => this.onLayoutChange('right', {visible: value === '1'})}/>
                    </div>
                    <div className="wea-portal-layout-toolbar-background">
                        {
                            right.visible ? (
                                <Popover ecId={`${this && this.props && this.props.ecId || ''}_Popover@0b3bbg`}
                                    trigger="click"
                                    placement="bottomRight"
                                    title={getLabel(387750, '背景设置')}
                                    content={<BackgroundSetting ecId={`${this && this.props && this.props.ecId || ''}_BackgroundSetting@nsz75n`} background={right.background} onChange={(background) => this.onLayoutChange('right', {background})}/>}
                                    overlayClassName="wea-portal-background-setting"
                                >
                                    <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                                </Popover>
                            ) : <i className='icon-coms-background' title={getLabel(387750, '背景设置')}/>
                        }
                    </div>
                    <div className="wea-portal-layout-toolbar-add" title={getLabel(390947, '添加右侧元素')} onClick={() => this.props.onAddElement(id, 'right')}>
                        <div className="wea-portal-layout-toolbar-add-area wea-portal-layout-toolbar-add-right">+</div>
                    </div>
                </div>

                <div className="wea-portal-layout-toolbar-btns">
                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@euymf1`} type="primary" onClick={this.props.onPreview}>{getLabel(221, '预览')}</Button>
                    <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@ptb35y`} type="primary" onClick={this.props.onSave}>{getLabel(30986, '保存')}</Button>
                </div>

            </div>
        );
    }

    onLayoutChange(position, obj) {
        const {layout = {}} = this.props;
        const {middle = {}, top = {}, bottom = {}, left = {}, right = {}} = layout;

        switch (position) {
            case 'middle':
                this.props.onLayoutChange({middle: {...middle, ...obj}});
                break;
            case 'top':
                // 默认配置
                const _top = {
                    visible: false,
                    height: 110,
                    cellRows: 0,
                    cellCols: 20,
                    cellWidth: '5%',
                    cellHeight: 15,
                    cellMarginX: 10,
                    cellMarginY: 10
                };
                this.props.onLayoutChange({top: {..._top, ...top, ...obj}});
                break;
            case 'bottom':
                // 默认配置
                const _bottom = {
                    visible: false,
                    height: 50,
                    cellRows: 0,
                    cellCols: 20,
                    cellWidth: '5%',
                    cellHeight: 15,
                    cellMarginX: 10,
                    cellMarginY: 10
                };
                this.props.onLayoutChange({bottom: {..._bottom, ...bottom, ...obj}});
                break;
            case 'left':
                // 默认配置
                const _left = {
                    visible: false,
                    width: 200,
                    cellRows: 0,
                    cellCols: 2,
                    cellWidth: '50%',
                    cellHeight: 15,
                    cellMarginX: 10,
                    cellMarginY: 10
                };
                this.props.onLayoutChange({left: {..._left, ...left, ...obj}});
                break;
            case 'right':
                // 默认配置
                const _right = {
                    visible: false,
                    width: 200,
                    cellRows: 0,
                    cellCols: 2,
                    cellWidth: '50%',
                    cellHeight: 15,
                    cellMarginX: 10,
                    cellMarginY: 10
                };
                this.props.onLayoutChange({right: {..._right, ...right, ...obj}});
                break;
        }
    }
}

export default Toolbar;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-layout/Toolbar.js